<template>
  <div class="CaliberLibraryList">
    <ul v-if="list.length>0">
      <li
        class="list_item"
        v-for="(item,i) in list_current"
        :key="i"
      >
        <div class="number_title">
          <span class="number">{{i+1}}</span>
          <span class="title">{{item.content}}</span>
          <span
            class="arrow"
            @click="changeShow(item)"
          >
            <i
              v-if="item.show"
              class="el-icon-arrow-up"
            ></i>
            <i
              v-else
              class="el-icon-arrow-down"
            ></i>
          </span>
        </div>
        <div
          class="tags_case"
          v-if="item.show"
        >
          <ul class="tags">
            <li
              v-for="(tagName,i) in item.tag"
              :key="'tag'+i"
            ><el-tag>{{tagName}}</el-tag></li>
          </ul>
          <div class="case">
            <div
              class="case_item_title"
              @click="link(item.eventId)"
            >
              <span class="case_item_title_prefix">相关案例：</span>
              {{item.eventName}}
            </div>
            <!-- <ul class="paragraph">
              <li class="paragraph_item">涉事品牌：{{item.brand}}</li>
              <li class="paragraph_item">危机类型：{{item.category}}</li>
              <li class="paragraph_item">首发平台：{{item.firstPlatform}}</li>
              <li class="paragraph_learn">舆情启示：{{item.learnText}}</li>
            </ul> -->
          </div>
        </div>
      </li>
    </ul>
    <DataNull v-else />
  </div>

</template>

<script>
import DataNull from '../components/DataNull'

export default {
  name: 'CaliberLibraryList',
  props: { list: Array },
  components: {
    DataNull
  },
  data () {
    return {
      list_current: []
    }
  },
  mounted () {
  },
  watch: {
    list () {
      this.list_current = this.list.map(t => {
        return {
          ...t,
          show: true,
          learnText: t.learning.map(t => t.content).join(',')
        }
      })
    }
  },
  methods: {
    link (eventId) {
      this.$router.push({ path: '/crisisDetails', query: { id: eventId } })
    },
    changeShow (item) {
      console.log('改变,', item)
      item.show = !item.show
    }
  }
}
</script>

<style lang="scss" scoped>
.CaliberLibraryList {
  margin-top: 24px;
  background-color: #ffffff;
  border-radius: 4px;
  padding: 30px;
  padding-top: 6px;
}
.list_item {
  margin: 24px 0;
  padding-bottom: 24px;
  border-bottom: 1px solid #eee;
  .number_title {
    display: flex;
    align-items: center;
    .number {
      width: 26px;
      height: 26px;
      border-radius: 4px;
      border: solid 1px #e7e7e9;
      line-height: 26px;
      text-align: center;
      color: #666;
    }
    .title {
      margin: 0 20px;
      width: 0;
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 16px;
      font-weight: bold;
      color: #444444;
    }
    .arrow {
      width: 26px;
      height: 26px;
      line-height: 26px;
      text-align: center;
      border-radius: 4px;
      border: solid 1px #e8ebf1;
      cursor: pointer;
      user-select: none;
    }
  }
  .tags_case {
    padding-left: 47px;
    .tags {
      margin-top: 25px;
      display: flex;
      column-gap: 10px;
    }
    .case {
      margin-top: 25px;
      padding: 20px;
      background-color: #fafafa;
      border-radius: 4px;
      overflow-y: auto;
      .case_item_title {
        color: #666;
        font-weight: bold;
        cursor: pointer;
        &:hover {
          color: #409eff;
        }
        .case_item_title_prefix {
          color: #999;
        }
      }
      .paragraph {
        margin-top: 20px;
        display: flex;
        column-gap: 50px;
        justify-content: space-between;
        color: #999;
        .paragraph_item {
          flex: 1;
        }
        .paragraph_learn {
          width: 0;
          flex: 3;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/CaliberLibrary/CaliberLibraryList.vue